// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kVVD","left":"styles_left__-IB1r"};